module.exports = __webpack_public_path__ + "img/exam (3).5e42f9cc.png";